import { clsx } from 'clsx';
import PropTypes from 'prop-types';

function ScrollableContainer({ defaultPadding, scrollable = true, customStyles = {}, children }) {
  return (
    <div
      className={clsx({
        'scrollableContainer': true,
        'scrollableContainer__defaultPadding': defaultPadding,
        'scrollableContainer-auto': scrollable,
        'scrollableContainer-clip': !scrollable,
      })}
      style={customStyles}
    >
      {children}
    </div>
  );
}

ScrollableContainer.propTypes = {
  defaultPadding: PropTypes.bool,
  children: PropTypes.node,
  scrollable: PropTypes.bool,
  customStyles: PropTypes.object,
};

export default ScrollableContainer;
